import Vue from 'vue';
window.Vue = Vue;
export default Vue;